import { IConfigSettings, TaxCalculation } from '../model/user.models';

export function isTurnoverTaxApplied(settings: IConfigSettings): boolean {
    return settings.stakeTaxRate !== 0 && settings.taxCalculation === TaxCalculation.TurnoverTax;
}
